package com.exura.components.layouts.nav

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.exura.components.icons.ExuraIcon
import com.exura.components.icons.ExuraText
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.minus

@Composable
internal fun Navigation(
    content: @Composable NavigationScope.() -> Unit,
) {
    var isCollapsed by remember { mutableStateOf(false) }
    val colorMode = ColorMode.current
    val navScope = NavigationScope(isNavigationCollapsed = isCollapsed)
    Column(
        verticalArrangement = Arrangement.spacedBy(Dimens.navNavigationEntriesGap),
        modifier = NavStyle.toModifier(
            if (isCollapsed) NavStyleCollapsed else null,
        ),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = Dimens.navLogoBottomSpace - Dimens.navNavigationEntriesGap)
                .height(Dimens.navLogoHeight),
        ) {
            ExuraIcon(
                modifier = Modifier
                    .fillMaxHeight()
                    .color(colorMode.toPalette().background),
            )
            ExuraText(
                modifier = NavTextStyle
                    .toModifier(if(isCollapsed) NavTextCollapsedVariant else null)
                    .fillMaxHeight()
                    .color(colorMode.toPalette().background),
            )
        }
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .minHeight(Dimens.spacingNone),
        ) {
            navScope.content()
        }
        navScope.ThemeToggle()
        navScope.SidebarCollapseTrigger(onToggle = { isCollapsed = !isCollapsed })
    }
}
